import React from "react";
import Header from "../HeaderOne/Main";
import Footer from "../FooterOne/Main";
import Breadcrumb from "../Breadcrumb/Main";
import DigitalMarketContent from "../Mendigital/DigitalMarketContent";
import FeaturesOne from "../Mendigital/FeaturesOne";
import FeaturesThree from "../Mendigital/FeaturesThree";
import ProcessFour from "../Mendigital/ProcessFour";
import JoinusOne from "../Mendigital/JoinusOne";
import TestimonialSix from "../Menservicedtls/TestimonialSix";


function Main() {
  return (
    <div>
      <Header />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <div className="page-wrapper-bg-1" />
            <div className="page-wrapper-bg-2" />
            <main className="site-main">
              <Breadcrumb title="Home" subtitle="Digital Marketing Details" />
              <DigitalMarketContent />
              <FeaturesOne />
              <FeaturesThree />
              <ProcessFour />
              <JoinusOne />
              <TestimonialSix />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
